// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';
import { useStore } from '@/store';

// models
import { CourseMeasurement } from '@/vue3/api/models';

export const useCourseMeasurementService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // methods
    const getCourseMeasurement = async (
        id: number,
    ): Promise<CourseMeasurement[]> => {
        const res = await axios.get(`${apiUrl}/course-measurement/${id}`);
        return res.data;
    };

    return {
        getCourseMeasurement,
    };
};
